import * as z from 'zod/v4'

// Identifies the surface that invoked a command — origin metadata stamped by the
// invoking surface, never chosen by the LLM (excluded from commandToolDefinitions),
// so the command receiver can attribute commands to their origin in analytics.
export const CommandCallerSchema = z.enum(['CHAT_ACROSS_YOUR_NOTES_LLM', 'ELECTRON_APP_SYSTEM_NOTIF'])

export type CommandCaller = z.infer<typeof CommandCallerSchema>
